"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _components = require("../components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function Charts(props) {
  var charts = props.charts,
    chartsInfo = props.chartsInfo,
    chartsTitles = props.chartsTitles,
    seriesTitles = props.seriesTitles,
    chartWidth = props.chartWidth,
    _props$chartWidthScal = props.chartWidthScaling,
    chartWidthScaling = _props$chartWidthScal === void 0 ? 1 : _props$chartWidthScal;
  return /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Row, {
    xs: "auto",
    className: "charts py-2 justify-content-center justify-content-md-start"
  }, charts.map(function (chart, idx) {
    return chartsInfo[chart] && /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Col, {
      className: "p-2",
      key: idx
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card, {
      style: {
        maxWidth: chartWidth
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card.Header, null, chartsTitles && chartsTitles[chart] || chart), /*#__PURE__*/_react["default"].createElement(_components.Chart, _extends({
      chartName: chart
    }, props, chartsInfo[chart], {
      chartWidth: chartWidth,
      widthScaling: chartWidthScaling
    })), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.Card.Footer, null, /*#__PURE__*/_react["default"].createElement(_components.ChartLegend, _extends({}, chartsInfo[chart], {
      seriesTitles: seriesTitles
    })))));
  }));
}
var _default = Charts;
exports["default"] = _default;